import * as components from './components';

export default [
  {
    path: '/masters/products',
    component: components.ProductList,
    name: 'productList',
    meta: { admin: true }
  }
];


// WEBPACK FOOTER //
// ./ClientApp/app/masters/products/routes.js